import React from 'react';
import { connect } from 'dva';
import { Select, Input } from 'antd';

class UserSelect extends React.Component {
  state = {
    usernameList: [],
  };
  
  componentDidMount() {
    const { dispatch, request } = this.props;
    if (this.isEditable()) {
      dispatch({ type: `userModel/${request || 'getUsersAdminUsernameList'}` }).then(
        (usernameList) => this.setState({ usernameList }),
      );
    }
  }

  isEditable = () => {
    const {
      editable,
      userModel: { adminRole },
    } = this.props;

    return editable === undefined ? adminRole : editable;
  };

  render() {
    const {
      editable,
      userModel: { profile },
      dispatch,
      value,
      ...others
    } = this.props;
    const { usernameList } = this.state;

    return this.isEditable() ? (
      <Select
        showSearch
        options={usernameList.map((item) => ({ label: item, value: item }))}
        value={value}
        {...others}
      />
    ) : (
      <Input
        readOnly
        value={value || profile.username}
        {...others}
      />
    );
  }
}

export default connect(({ userModel }) => ({
  userModel,
}))(UserSelect);
